/** Whether `itemPath` is the current route or an ancestor of it; the root path only matches itself. */
export function isActivePath(currentPath: string, itemPath: string): boolean {
  if (itemPath === '/')
    return currentPath === '/'
  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`)
}
